// import Vue from "vue";
// import store from "..";
const currentUser = {};

currentUser.state = {
  currentUserName: null,
  currentUserEmail: null,
  currentUserSub: null,
  currentUserRegInitialized: null
};

currentUser.mutations = {
  changeCurrentUserName(state, currentUserName) {
    state.currentUserName = currentUserName;
  },
  changeCurrentUserEmail(state, currentUserEmail) {
    state.currentUserEmail = currentUserEmail;
  },
  changeCurrentUserSub(state, currentUserSub) {
    state.currentUserSub = currentUserSub;
  },
  changeCurrentUserRegInitialized(state, currentUserRegInitialized) {
    state.currentUserRegInitialized = currentUserRegInitialized;
  }
};

currentUser.actions = {};

currentUser.getters = {
  getCurrentUserName(state) {
    return state.currentUserName;
  },
  getCurrentUserEmail(state) {
    return state.currentUserEmail;
  },
  getCurrentUserSub(state) {
    return state.currentUserSub;
  },
  getCurrentUserRegInitialized(state) {
    return state.currentUserRegInitialized;
  }
};

export default currentUser;
